export const OBTER_CIDADES = 'OBTER_CIDADES';
export const LOGIN = 'LOGIN';

// Importar fotos
export const IMPORTAR_FOTO_BUSCAR_TAXISTA = 'IMPORTAR_FOTO_BUSCAR_TAXISTA';
export const VALIDAR_ARQUIVO_IMPORTACAO_TAXISTA = 'VALIDAR_ARQUIVO_IMPORTACAO_TAXISTA';
export const IMPORTAR_ARQUIVO_TAXISTA = 'IMPORTAR_ARQUIVO_TAXISTA';